export const data = {


    scene: '03_kolmipistekävely',
    kysymysteksti: 'Valitse oikea kävelytekniikka tilanteeseen, jossa vasemman alaraajan askelta on kevennettävä',
    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: 'Hyvä tekniikka',
            valinta: '3_piste',
            ohjaajan_palaute: 'Noinhan se 3-pistekävely menee',
            koontiteksti: '',
            pisteet: 1,
            arviointitiedosto: 'scene_03_3_piste_kavely_ok',
            harjoiteltava: [''],
            ammattitaitovaatimukset: [
                {
                    vaatimus: '',
                    osaamistaso: 0,
                    relevantit_kriteerit: [
                        {
                            kriteeri: '',
                            toteutui: ''
                        }
                    ]
                }
            ]
        },

        {
            id: 2,
            teksti: 'Huono tekniikka jos jaloissa puolieroa',
            valinta: '2_piste',
            ohjaajan_palaute: 'Tuo kävelytekniikka ei oikein sovi Pentille ',
            koontiteksti: '',
            pisteet: 0,
            arviointitiedosto: 'scene_03_3_piste_kavely_ei_ok',
            harjoiteltava: ['sauvakävelytekniikat'],
            ammattitaitovaatimukset: [
                {
                    vaatimus: '',
                    osaamistaso: 0,
                    relevantit_kriteerit: [
                        {
                            kriteeri: '',
                            toteutui: ''
                        }
                    ]
                }
            ]
        },
        {
            id: 3,
            teksti: 'Huono tekniikka jos jaloissa puolieroa',
            valinta: '4_piste',
            ohjaajan_palaute: 'Tuo kävelytekniikka ei oikein sovi Pentille',
            koontiteksti: '',
            pisteet: 0,
            arviointitiedosto: 'scene_03_3_piste_kavely_ei_ok',
            harjoiteltava: ['sauvakävelytekniikat'],
            ammattitaitovaatimukset: [
                {
                    vaatimus: '',
                    osaamistaso: 0,
                    relevantit_kriteerit: [
                        {
                            kriteeri: '',
                            toteutui: ''
                        }
                    ]
                }
            ]
        },
        {
            id: 4,
            teksti: 'Ei sovi jalkavaivaiselle tämmöinen',
            valinta: 'hyppy',
            ohjaajan_palaute: 'Onko tämä sitä opiskelijahuumoria?',
            koontiteksti: '',
            pisteet: 0,
            arviointitiedosto: 'scene_03_3_piste_kavely_ei_ok',
            harjoiteltava: ['sauvakävelytekniikat'],
            ammattitaitovaatimukset: [
                {
                    vaatimus: '',
                    osaamistaso: 0,
                    relevantit_kriteerit: [
                        {
                            kriteeri: '',
                            toteutui: ''
                        }
                    ]
                }
            ]
        },


    ]


};